import React, { useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/ScrollTop';

// ✅ Component to track page views
const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if Meta Pixel is loaded
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        page_path: location.pathname
      });
    }
  }, [location]);

  return null;
};

const AppShell = () => {
  const location = useLocation();
  const isApplyNew = location.pathname === "/apply-new";
  const isApplyLoan = location.pathname === "/apply-loan";
  const isApplyNow = location.pathname === "/apply-now";
  const isLanding = location.pathname === "/landing";
  const hideChrome = isApplyNew || isApplyLoan || isApplyNow || isLanding;

  return (
    <>
      <MetaPixelTracker />
      <ScrollTop />
      {!hideChrome && <ScrollToTopButton />}
      {!hideChrome && <Navbar />}
      <AppRoutes />
      {!hideChrome && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
